import { useLocationSearchQuery } from './useLocationSearchQuery';
import { useListDetailsContext } from '../contexts/listDetails';
import { PAGE_VARIATIONS } from '../constants';
import { useUpdateQueryWithCatalog } from './useUpdateQueryWithCatalog';

/**
 * Hook that houses any prepopulated query
 */

export const usePrepopulatedSegmentationQuery = () => {
  const { pageVariation, searchQuery } = useListDetailsContext();
  const locationSearchQuery = useLocationSearchQuery();
  const updatedQueryWithCatalog = useUpdateQueryWithCatalog(searchQuery);

  // existing query for dynamic list
  if (pageVariation === PAGE_VARIATIONS.DYNAMIC) {
    return updatedQueryWithCatalog;
  }

  // query that comes from location state
  if (pageVariation === PAGE_VARIATIONS.SEGMENTATION && locationSearchQuery) {
    return locationSearchQuery;
  }
};
